// DO NOT CHANGE THIS FILE
// This file is automatically generated during package installation

export var packageVersion = '0.34.4';